/* eslint-disable no-shadow */
import React, { createContext, useReducer } from 'react';

const initialState = {
    burgerMenuVisible: false,
    registerInterestOverlayVisible: false,
    disclaimerOverlayVisible: false,
    fullscreenOverlayVisible: false,
    fullscreenOverlayScrollVisible: false,
    lightBgEnabled: false,
    userSkipped: false,
};
const StateContext = createContext({ state: initialState });
const { Provider } = StateContext;

const StateProvider = ({ children }) => {
    const [state, dispatch] = useReducer((state, action) => {
        const newState = { ...state };
        switch (action.type) {
            case 'ROUTE_LOAD':
                break;

            case 'ROUTE_UNLOAD':
                break;

            case 'SHOW_BURGER_MENU':
                newState.burgerMenuVisible = true;
                break;

            case 'HIDE_BURGER_MENU':
                newState.burgerMenuVisible = false;
                break;

            case 'SHOW_REGISTER_INTEREST_OVERLAY':
                newState.registerInterestOverlayVisible = true;
                break;

            case 'HIDE_REGISTER_INTEREST_OVERLAY':
                newState.registerInterestOverlayVisible = false;
                break;

            case 'SHOW_DISCLAIMER_OVERLAY':
                newState.disclaimerOverlayVisible = true;
                newState.disclaimerdata = action.disclaimerdata;
                break;

            case 'HIDE_DISCLAIMER_OVERLAY':
                newState.disclaimerOverlayVisible = false;
                newState.disclaimerdata = null;
                break;

            case 'SHOW_FULLSCREEN_OVERLAY':
                newState.fullscreenOverlayVisible = true;
                break;

            case 'HIDE_FULLSCREEN_OVERLAY':
                newState.fullscreenOverlayVisible = false;
                break;

            case 'SHOW_FULLSCREEN_OVERLAY_SCROLL':
                newState.fullscreenOverlayScrollVisible = true;
                break;

            case 'HIDE_FULLSCREEN_OVERLAY_SCROLL':
                newState.fullscreenOverlayScrollVisible = false;
                break;

            case 'SHOW_DEVICE_OVERLAY':
                newState.deviceOverlayVisible = true;
                break;

            case 'HIDE_DEVICE_OVERLAY':
                newState.deviceOverlayVisible = false;
                break;

            case 'SET_BACKGROUND_LIGHT':
                newState.lightBgEnabled = true;
                break;

            case 'SET_BACKGROUND_DARK':
                newState.lightBgEnabled = false;
                break;

            case 'SET_USER_SKIPPED':
                newState.userSkipped = true;
                break;

            case 'RESET_USER_SKIPPED':
                newState.userSkipped = false;
                break;

            default:
                throw new Error();
        }

        return newState;
    }, initialState);

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { StateContext, StateProvider };
